// useChatObserver.js
import {debounce} from "lodash-es";

/**
 * @param {Object} params
 * @param {messagesContainer<HTMLElement>} params.messagesContainer — контейнер с сообщениями
 * @param {Function} params.markMessagesAsRead — функция пометки сообщений
 * @returns {Object} observer
 */
export function useChatObserver({messagesContainer, markMessagesAsRead}) {
    const debouncedMarkAsRead = debounce((date) => {
        markMessagesAsRead(date);
    }, 500);

    let observer = null;

    // Логика работы с сообщениями
    const setupObserver = () => {
        if (!messagesContainer.value) return null;

        observer = new IntersectionObserver((entries) => {
            let newestVisibleDate = null;

            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const messageDate = entry.target.dataset.messageCreated_at;
                    const isUnread = entry.target.classList.contains('unread-message');
                    if (isUnread && (!newestVisibleDate || new Date(messageDate) > new Date(newestVisibleDate))) {
                        newestVisibleDate = messageDate;
                    }
                }
            });

            if (newestVisibleDate) {
                debouncedMarkAsRead(newestVisibleDate);
            }
        }, {
            root: messagesContainer.value,
            threshold: 0.5,
            rootMargin: '0px 0px -60px 0px'
        });

        return observer;
    };

    const observeMessages = () => {
        if (!observer || !messagesContainer.value) return;
        const messageElements = messagesContainer.value.querySelectorAll('.message');
        messageElements.forEach(el => observer.observe(el));
    };

    const disconnectObserver = () => {
        if (observer) observer.disconnect();
    };

    return {
        setupObserver,
        observeMessages,
        disconnectObserver,
    };
}
